<div class="kpi-container">
  <div class="kpi-item" *ngFor="let kpi of list; let i = index">
    <img [src]="kpi.icon" alt="" />
    <p>{{ kpi.title }}</p>
  </div>
</div>
